<ion-app>
  @if(showSidebar) {
    <ion-split-pane contentId="main-content">
      
      <div class="ion-page" id="main-content">
        
        <ion-header class="ion-no-border premium-header">
          <ion-toolbar mode="ios"> 
            <ion-buttons slot="start" style="padding-left: 16px;">
              <div class="logo-container" style="display: flex; align-items: center; justify-content: center;">
                <img src="assets/Ark system aw logo.png" alt="Ark Logo" style="height: 55px; width: auto; object-fit: contain; display: block;" />
              </div>
            </ion-buttons>
        
            <ion-title></ion-title>

            <ion-buttons slot="end" style="padding-right: 16px;">
              <button class="premium-avatar-btn" id="profile-popover-trigger" style="display: flex; align-items: center; justify-content: center; background: transparent; border: none; padding: 0;">
                <div class="avatar-circle">
                  <span>{{ authService.currentUser()?.name?.substring(0, 2)?.toUpperCase() }}</span> 
                </div>
              </button>
            </ion-buttons>

          </ion-toolbar>
        </ion-header>

        <ion-popover trigger="profile-popover-trigger" triggerAction="click" dismissOnSelect="true" class="ux-premium-dropdown">
          <ng-template>
            <div class="dropdown-wrapper">
              
              <div class="dropdown-header">
                <p class="user-name">{{ 'PROFILE_MENU.NAME' | translate }}</p>
                <p class="user-email">{{ authService.currentUser()?.name }}</p>
              </div>
              
              <div class="dropdown-divider-line"></div>
        
              <div class="dropdown-menu-list">
                
                <button class="menu-action-item" (click)="goToSettings()">
                  <div class="icon-box">
                    <ion-icon name="settings-outline"></ion-icon>
                  </div>
                  <span>{{ 'PROFILE_MENU.ACCOUNT_SETTINGS' | translate }}</span>
                </button>
        
                <button class="menu-action-item logout-action" (click)="logout()">
                  <div class="icon-box alert-icon">
                    <ion-icon name="log-out-outline"></ion-icon>
                  </div>
                  <span>{{ 'PROFILE_MENU.LOGOUT' | translate }}</span>
                </button>
        
              </div>
            </div>
          </ng-template>
        </ion-popover>

        <ion-router-outlet></ion-router-outlet>
          
        @if(showTab){
          <div class="tabs-container">
            <ion-tab-bar slot="bottom" class="custom-brutal-tabs">
              
              <ion-tab-button tab="inbox" routerLink="/home" routerLinkActive="active-tab">
                <div class="icon-wrapper">
                  <ion-icon name="home-outline" class="inactive-icon"></ion-icon>
                  <ion-icon name="home" class="active-icon"></ion-icon>
                </div>
              </ion-tab-button>
          
              <ion-tab-button tab="stats" routerLink="/podium" routerLinkActive="active-tab">
                <div class="icon-wrapper">
                  <ion-icon name="calendar-outline"></ion-icon>
                </div>
              </ion-tab-button>
          
              <ion-tab-button tab="create-job-order" routerLink="/jobs-list" routerLinkActive="active-tab">
                <div class="icon-wrapper">
                  <ion-icon name="car-sport-outline"></ion-icon>
                </div>
              </ion-tab-button>

              <ion-tab-button tab="profile" routerLink="/profile" routerLinkActive="active-tab">
                <div class="icon-wrapper">
                  <ion-icon name="person-outline" class="inactive-icon"></ion-icon>
                  <ion-icon name="person" class="active-icon"></ion-icon>
                </div>
              </ion-tab-button>
          
            </ion-tab-bar>
          </div>
        }

      </div>
    </ion-split-pane>
  }
  @else {
    <ion-router-outlet id="main-content"></ion-router-outlet>
  }
</ion-app>